'use strict'
angular.module('broadcastInputPasswordModule', [])
    .controller('broadcastInputPasswordCtrl', ['$scope', '$modalInstance', 'modalDialog', function($scope, $modalInstance, modalDialog) {
        $scope.confirm = function() {
            if ($scope.password === "" || !angular.isDefined($scope.password)) {
                modalDialog.alertType("请输入密码", "", "warning", false);
            } else {
                $modalInstance.close($scope.password);
            }
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);